var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{ref:"map",staticClass:"map pa-2"}),_c('v-alert',{attrs:{"value":_vm.showError,"color":"red","type":"error"}},[_vm._v(" "+_vm._s(`${_vm.currentImage.filename} does not contain any location data`)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }